import ImagesUrl from "#constants/images.js";
import React, { useEffect, useRef, useState } from "react";
import { ClipLoader } from "react-spinners";
import { useLocation, useNavigate } from "react-router-dom";
import { AlertTost } from "#components";
import { WebRoutePath } from "#routes/routePath.jsx";
import ENDPOINTS from "#services/endPoints.js";
import QUERY_KEYS from "#services/queryKeys.js";
import usePost from "#hooks/usePost.js";
import toast from "react-hot-toast";

const VerifyOtp = () => {
  const location = useLocation();
  const nav = useNavigate();

  const inputRefs = useRef([]);
  const [otpValues, setOtpValues] = useState(Array(4).fill(""));
  const [isInputFilled, setIsInputFilled] = useState(false);
  const [error, setError] = useState(false);
  const [timeLeft, setTimeLeft] = useState(120);
  const [isTimerDone, setIsTimerDone] = useState(false);

  const {
    mutateAsync: verifyOtpMutateAsync,
    isLoading: isLoadingVerifyOtp,
    error: errorVerifyOtp,
  } = usePost(ENDPOINTS.VERIFY_OTP, QUERY_KEYS.VERIFY_OTP_QUERY_KEY);
  const {
    mutateAsync: resendOtpMutateAsync,
    isLoading: isLoadingResendOtp,
    error: errorREsendOtp,
  } = usePost(ENDPOINTS.RESEND_OTP, QUERY_KEYS.RESEND_OTP_QUERY_KEY);

  function handleInputChange(event, index) {
    const value = event.target.value;
    // Update OTP values array
    const newOtpValues = [...otpValues];
    newOtpValues[index] = value;
    setOtpValues(newOtpValues);
    setError(false);
    // Move focus forward if the current input is filled
    if (value.length === 1 && index < inputRefs.current.length - 1) {
      inputRefs.current[index + 1].focus();
      setError(false);
    }
    // Move focus backward if the current input is empty
    else if (value.length === 0 && index > 0) {
      inputRefs.current[index - 1].focus();
      setError(true);
    }
  }

  async function handleVerifyClick() {
    try {
      if (!isInputFilled) {
        setError(true);
      } else {
        const response = await verifyOtpMutateAsync({
          email: location?.state,
          emailOtp: otpValues.join(""),
        });
        if (response?.status === true) {
          nav(WebRoutePath.RESET_PASSWORD.path, { state: location?.state });
          AlertTost(response.message, "success");
        }
      }
    } catch (error) {
      if (error?.response?.status === 400) {
        toast.dismiss();
        AlertTost(error?.response?.data?.message, "error");
      }
    }
  }

  // Resend OTP click handler (implement resend OTP API call here)
  const handleResendOtp = async () => {
    const response = await resendOtpMutateAsync({ email: location?.state });
    if (response?.status === true) {
      AlertTost(response.message, "success");
      setOtpValues(Array(4).fill(""));
    } else {
      toast.dismiss();
      AlertTost(error?.response?.data?.message, "error");
    }
    setTimeLeft(120);
    setIsTimerDone(false);
  };

  // Timer logic to update time left every second
  useEffect(() => {
    if (timeLeft > 0) {
      const timer = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);
      return () => clearInterval(timer); // Cleanup interval on component unmount
    } else {
      setIsTimerDone(true); // When timeLeft reaches 0, set timer as done
    }
  }, [timeLeft]);
  // Update the isInputFilled state whenever OTP values change
  useEffect(() => {
    const filled = otpValues.every((value) => value !== "");
    setIsInputFilled(filled);
  }, [otpValues]);

  // Format timeLeft to MM:SS format
  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes}:${seconds < 10 ? "0" + seconds : seconds}`;
  };

  return (
    <div className="login-main">
      <div className="login-logo-main">
        <img src={ImagesUrl.loginBackground} alt="" />
      </div>
      <div
        className="login-form-main"
        data-aos="fade-right"
        data-aos-duration="1500"
      >
        <div className="login-card-item">
          <div className="inner-content">
            <div className="text-center">
              <h1 className="">Verify Otp !</h1>
              <p> Please enter your otp for verification</p>
            </div>
            <div>
              <ul className="otp-input-block">
                {[0, 1, 2, 3].map((index) => (
                  <li key={index}>
                    <input
                      maxLength={1}
                      value={otpValues[index]}
                      ref={(el) => (inputRefs.current[index] = el)}
                      onChange={(event) => handleInputChange(event, index)}
                      onInput={(event) => {
                        // Only allow numeric input
                        event.target.value = event.target.value.replace(
                          /[^0-9]/g,
                          ""
                        );
                      }}
                    />
                  </li>
                ))}
              </ul>

              {error && (
                <p style={{ color: "red", marginBottom: "0px" }}>
                  Please enter valid otp*
                </p>
              )}
            </div>
            <div className="form-main"></div>
          </div>
          <button
            type="button"
            disabled={isLoadingVerifyOtp}
            onClick={handleVerifyClick}
          >
            {isLoadingVerifyOtp ? (
              <ClipLoader size={17} color="#fff" />
            ) : (
              "Verify Otp"
            )}
          </button>
          {timeLeft > 0 && (
            <p className="mt-2 mb-0 text-center">
              You can resend OTP in{" "}
              <span className="text-danger">{formatTime(timeLeft)}</span>
            </p>
          )}
          {isTimerDone && (
            <div className="d-flex justify-content-center">
              <button
                className="resend_otp_btn"
                type="button"
                onClick={handleResendOtp}
              >
                Resend Otp
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default VerifyOtp;
